// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--e1693";
export var label = "style-module--label--7af1c";
export var option = "style-module--option--fbdc6";
export var select = "style-module--select--722ae";